import { render, staticRenderFns } from "./create-dialog.pug?vue&type=template&id=a3686972&scoped=true&lang=pug&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./create-dialog.scss?vue&type=style&index=0&id=a3686972&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3686972",
  null
  
)

export default component.exports